// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76542253","455":"70d79004","977":"2dba5b18"}[chunkId] + ".chunk.js";
};